<template>
	<v-text-field
		single-line
		outline
		hide-details
		type="tel"
		ref="field"
		:value="value"
		size="9"
		class="currency-field"
		@input="change"
		@blur="update"
	>
		<template v-slot:prepend-inner v-if="!hideIcon">
			<span v-show="isNegative">-</span>
			<span>$</span>
		</template>
	</v-text-field>
</template>

<script>
export default {
	data() {
		return {
			disabled: true
		};
	},

	props: {
		value: {
			default: 0
		},

		hideIcon: {
			default: false
		},

		isNegative: {
			default: false
		}
	},

	methods: {
		change(value) {
			if (!isNaN(value)) {
				this.$emit("input", value);
			}
		},

		update() {
			const value = parseFloat(this.value).toFixed(2);

			if (!isNaN(value)) {
				this.change(value);
				this.$emit("blur", value);
			}
		}
	},

	created() {
		this.change(parseFloat(this.value).toFixed(2));
	}
};
</script>
